import "//shopakaso.com/cdn/shop/t/25/assets/swiper@11.min.js?v=104684603862494721831780911930"
import "//shopakaso.com/cdn/shop/t/25/assets/jquery.js?v=147293088974801289311780911872"

// 入口函数，在页面加载完成后执行
function main() {
    Alpine.data('storeBannermb', function () {
        const el = $(this);
        return {
            swiperOptionFour: {
                initialSlide: 0,
                direction: 'horizontal',
                loop: true,
                autoplay: {
                  delay: 3000,
                  stopOnLastSlide: false,
                  disableOnInteraction: true,
                },
                pagination: {
                  el: '.swiper-pagination-four',
                  renderBullet(index, className) {
                    return `<span class="${className}">
                              <span class="swiper-pagination-bullet-progress"></span>
                            </span>`
                  },
                },
                navigation: {
                  nextEl: '.swiper-button-next-four',
                  prevEl: '.swiper-button-prev-four',
                },
                slidesPerView: 'auto',
                spaceBetween: 0,
                slidesOffsetBefore: 0,
                on: {
                  slideChangeTransitionEnd() {
                    this.autoplay.start()
                  },
                },
            },
            localName: window.Shopify.locale,
            init() {
                /* 页面刷新时执行 */
                window.onload = function () {
                    if (document.body.scrollTop > 0) {
                        window.scrollTo(0, -1)
                        document.body.scrollTop = 0
                    }
                    window.scrollTo(0, -1)
                    document.body.scrollTop = 0
                }
                /* 页面刷新时执行 */
                this.initMB()
            }, // end init
            initMB() {
                this.initMBSwiper()
            },
            initMBSwiper() {
                new Swiper('.swiper-container-banner-mb', this.swiperOptionFour)
            },
        }
    })
}
document.addEventListener('alpine:init', main)